import * as React from "react";
import { forwardRef } from "react";
const SvgFullscreenEnter = (props, ref) => /* @__PURE__ */ React.createElement("svg", {
	fill: "currentColor",
	height: "1em",
	viewBox: "0 0 24 24",
	width: "1em",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props
}, /* @__PURE__ */ React.createElement("path", {
	d: "M0 0h24v24H0z",
	fill: "none"
}), /* @__PURE__ */ React.createElement("path", { d: "M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zM14 5v2h3v3h2V5h-5z" }));
const ForwardRef = forwardRef(SvgFullscreenEnter);
export default ForwardRef;
